import { useCreateBooking } from "$api/client";
import {
  BLOCKED_SLOT_LICENSEPLATE,
  DATE_TIME_FORMAT,
  TIME_FORMAT,
} from "$utils";
import { Button, Popconfirm } from "antd";
import dayjs from "dayjs";

const BlockTimeSlot = ({ locationId, locationSlot }) => {
  const createBooking = useCreateBooking(locationId);

  const confirm = () => {
    const fields = {};
    fields["crm_dealercode"] = locationSlot.crm_dealercode;
    fields["date"] = locationSlot.date;
    fields["license_plate"] = BLOCKED_SLOT_LICENSEPLATE;
    fields["wheels_stored"] = "false";
    fields["team"] = locationSlot.team;
    fields["location_id"] = locationId;
    createBooking.mutate(fields);
  };

  let time = "";
  time = dayjs(locationSlot.date).format(TIME_FORMAT);
  const dateTime = dayjs(locationSlot.date).format(DATE_TIME_FORMAT);

  return (
    <>
      <Popconfirm
        title="Termin sperren"
        description={`Möchten Sie den Termin am ${dateTime} für einen eigenen Vorführwagen reservieren?`}
        onConfirm={confirm}
        okText="Ja"
        cancelText="Nein"
      >
        <Button type="link" style={{ marginBottom: "-40px" }}>
          {time}
        </Button>
      </Popconfirm>
    </>
  );
};

export default BlockTimeSlot;
